"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccordionItem = undefined;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Box = require("../Box");

var _Box2 = _interopRequireDefault(_Box);

var _Text = require("../Text");

var _Text2 = _interopRequireDefault(_Text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Radio = (0, _styledComponents2.default)("input").withConfig({
  displayName: "AccordionItem__Radio",
  componentId: "g1hqm1-0"
})(["margin-right:8px;"]);

const AccordionItem = exports.AccordionItem = ({ selected, title, onChange, children }) => _react2.default.createElement(
  _Box2.default,
  { className: "AccordionItem", border: 1, lineHeight: 2 },
  _react2.default.createElement(
    _Box2.default,
    { p: 2 },
    _react2.default.createElement(
      _Text2.default,
      { as: "label", ml: 2, color: "palette.ink.normal", fontSize: 1 },
      _react2.default.createElement(Radio, { type: "radio", onChange: onChange, checked: selected }),
      " ",
      title
    )
  ),
  selected && children && _react2.default.createElement(
    _Box2.default,
    { p: 0, pr: 3, pl: 5, bg: "palette.cloud.light", borderTop: 1 },
    children
  )
);

AccordionItem.propTypes = {
  id: _propTypes2.default.string,
  selected: _propTypes2.default.bool,
  title: _propTypes2.default.string,
  onChange: _propTypes2.default.func,
  children: _propTypes2.default.node
};

exports.default = AccordionItem;